import * as countries from "@/constants/countries"
const PhoneNumber = require('awesome-phonenumber');

export default {
  name: "signup-modal",
  props: ["auth"],
  components: {},
  data() {
    return {
      form: {
        fname: "",
        lname: "",
        phone: "",
        email: "",
        hash: "",
      },
      selectedCountry: null,
      fullPhone: "",
      selectedCountryCode: countries.data.find(country => country.name.toLowerCase() === "nigeria").dial_code,
      countries: countries.data,
      showPassword: false,
      phoneValid: false
    };
  },
  computed: {
    formValid: function() {
      return (!Object.entries(this.form).map(s => s[0] !== "" && s[1]).find(s => s === "") &&
        this.form.hash.length >= 6 && this.validEmail() && this.phoneValid);
    },
  },
  methods: {
    validEmail: function() {
      let flag;
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      flag = re.test(String(this.form.email).toLowerCase());
      return flag;
    },
    submit: function(e) {
      if (!this.formValid) {
        return
      }
      
      const btn = e.submitter;

      const form = {
        phone: this.fullPhone,
        email: this.form.email,
        fullName: `${this.form.fname} ${this.form.lname}`,
        hash: this.form.hash
      }

      btn.innerText = "Creating your account";
      btn.disabled = true;
      btn.classList.add("btn--loading");

      this.$props.auth
        .signupDefault(form)
        .then(response => {
          $("#signupModal").modal("hide");
          this.$props.auth.setSession(response, "default");
        })
        .catch(response => {
          this.$root.$emit("ShowErrorNotification", response.message);

          btn.innerText = "Create my account";
          btn.classList.remove("btn--loading");
          btn.disabled = false;
        });
    },
    show: function() {
      try {
        this.showPassword = !this.showPassword;
      } catch (e) {}
    }
  },
  watch: {
    "selectedCountryCode": {
      handler: function(val) {
        this.selectedCountry = this.countries.find(country => country.dial_code === val);
        const phone = new PhoneNumber(this.form.phone, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        }
      },
      immediate: true,
      deep: true
    },
    "form.phone": {
      handler: function(val) {
        const phone = new PhoneNumber(val, this.selectedCountry.code).a;
        if (phone.possibility !== "unknown") {
          this.fullPhone = phone.number["e164"];
          this.phoneValid = phone.valid;
        } else {
          this.phoneValid = phone.false;
        }
      }
    }
  }
};
